<template>
    <div>
        <el-tabs
            class="gcmcn-tabs"
            style="margin-top: 30px;"
            v-model="activeName"
            :key="selectedEntity.uid"
        >
            <el-tab-pane label="Details" name="details">
                <div class="gcmcn-card-gradient entity-details">

                    <el-button
                        type="primary"
                        class="gcmcn-primary-btn small edit-entity"
                        @click="editEntity"
                    >Edit</el-button>
                    <el-row :gutter="0">
                        <el-col :span="12">
                            <div class="details-title">Name</div>
                            <div>{{ selectedEntity.display_name }}</div>
                        </el-col>
                        <el-col :span="12">
                            <div class="details-title some-space">Logo</div>
                            <img class="entity-logo" :src="selectedEntity.logo">
                        </el-col>
                    </el-row>
                    <div class="details-title">Globecast region</div>
                    <div class="details-text">{{datacenter?datacenter.name:'No Globecast region'}}</div>
                    <div class="details-title">AWS dispatch region</div>
                    <div class="details-text">{{selectedRegion.display_name}}</div>
                    <div class="details-title">Image</div>
                    <img class="entity-image" :src="selectedEntity.image">


                    <el-divider></el-divider>
                    <ns-loader
                        ref="ns-loader"
                        :toLoad="toLoad"
                        :custom-scope="entityScope"
                        @dataFetched="onDataFetched"
                    >
                        <loading-template slot="loader"></loading-template >
                        <div slot="content">
                            <div style="font-weight: bold;">{{ eventsFiltered.length }} event(s)</div>
                            <gcmcn-filters
                                :filter-values="[selectedSortType, searchFilter]"
                                @reset-filters="resetFilters"
                            >
                                <dropdown
                                    name="Sort"
                                    :multiple="false"
                                    :list="$store.getters.sortTypeList"
                                    itemName="name"
                                    itemValue="value"
                                    :itemsSelected="selectedSortType.length > 0 ? [selectedSortType] : []"
                                    @on-select-item="selectedSortType = $event"
                                ></dropdown>
                                <search-filter ref="search" @new-value="searchFilter = $event"></search-filter>
                            </gcmcn-filters>
                            <template v-if="eventsFiltered.length > 0">
                                <event
                                    v-for="event in eventsFiltered"
                                    :key="event.uid"
                                    :event="event"
                                    :universes="universes"
                                ></event>
                            </template>
                            <div v-else class="list-empty">
                                No events related to this entity.
                            </div>
                        </div>
                    </ns-loader>
                </div>
            </el-tab-pane>
            <el-tab-pane
                v-if="userIsAtLeastAdmin"
                label="Entity Admins"
                name="entity-admins"
            >
                <user-list
                    :entity="selectedEntity"
                    @trigger-refresh="triggerRefresh()"
                    role="ENTITY_ADMIN"
                ></user-list>
            </el-tab-pane>
            <el-tab-pane
                v-if="userIsAtLeastAdmin || userIsEntityAdmin(this.selectedEntity.uid)"
                label="Managers"
                name="managers"
            >
                <user-list
                    :entity="selectedEntity"
                    role="MANAGER"
                ></user-list>
            </el-tab-pane>
            <el-tab-pane
                v-if="userIsAtLeastAdmin || userIsAtLeastManager"
                label="Export"
                name="Export"
            >
                <export-view
                    :takers-to-export="takersToExport"
                    :feed-resource-to-export="feedResourceToExport"
                    :events-to-export="eventsToExport"
                    :entity="selectedEntity"
                ></export-view>
            </el-tab-pane>
            <el-tab-pane
                label="Import feeds"
                name="import"
            >
                <import-view
                    ref="importview"
                    :entity="selectedEntity"
                ></import-view>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>

import {
    GcmcnFilters,
    Dropdown,
    SearchFilter ,
} from 'gcmcn-common';
import Event from './event.vue';
import NsLoader from 'fundation-app-vuejs/src/components/partials/ns-vue-loader';
import UserList from './user-list.vue';
import ImportView from './import-feeds-view.vue';
import LoadingTemplate from '../../partials/ns-loader-template.vue';
import ExportView from './export-view.vue';
import { mapGetters } from 'vuex';

export default {

    components: {
        GcmcnFilters,
        Dropdown,
        SearchFilter,
        Event,
        NsLoader,
        LoadingTemplate,
        UserList,
        ImportView,
        ExportView
    },

    props: {
        selectedEntity: {
            type: Object,
            required: true,
        },
    },

    data (){
        return {
            activeName: 'details',
            toLoad: [
                {
                    name: 'events',
                    model: 'events',
                    filters: {
                        archived: false,
                    }
                },
                {
                    name: 'universes',
                    model: 'universes',
                },
                {
                    name: 'feedResources',
                    model: 'feedResources',
                    filters: {
                        archived: false,
                        status__in: 'RUNNING,STOPPED,STOP_REQUESTED,STOPPING',
                    }
                },
            ],
            events: [],
            feedResources: [],
            universes: [],
            selectedSortType: '',
            searchFilter: '',
        };
    },

    computed: {
        ...mapGetters([
            'datacentersByUid',
            'awsregions',
            'userIsAtLeastAdmin',
            'userIsEntityAdmin',
            'userIsAtLeastManager',
            'takers'
        ]),
        takersToExport(){
            return this.takers.filter((taker) => taker.scopes.entity_uid === this.selectedEntity.uid);
        },
        feedResourceToExport(){
            return this.feedResources.filter((resource) => resource.scopes.entity_uid === this.selectedEntity.uid);
        },
        eventsToExport(){
            return this.events.filter((event) => event.scopes.entity_uid === this.selectedEntity.uid);
        },
        entityScope (){
            return { 'X-Entity-Uid': this.selectedEntity.uid};
        },
        datacenter(){
            return this.datacentersByUid(this.selectedEntity.datacenter_uid)
        },
        selectedRegion(){
            if(this.selectedEntity.aws_dispatch_region_uid){
                return this.awsregions.find(region => region.uid === this.selectedEntity.aws_dispatch_region_uid);
            }
        },
        eventsFiltered (){
            let events = this.events.slice();
            if(this.selectedSortType){
                events.sort((a, b) => a.name.localeCompare(b.name));
                if(this.selectedSortType === 'dsc'){
                    events.reverse();
                }
            }
            if(this.searchFilter){
                events = events.filter((u) => u.name.toLowerCase().includes(this.searchFilter.toLowerCase()));
            }
            return events;
        },
    },

    mounted (){

    },

    methods: {
        onDataFetched (res){
            this.$set(this, 'events', res.events);
            this.$set(this, 'universes', res.universes);
            this.$set(this, 'feedResources', res.feedResources);
        },
        resetFilters (){
            this.selectedSortType = '';
            this.$refs.search.clear();
        },
        editEntity (){
            this.$emit('on-edit-entity');
        },
    },
};
</script>

<style lang="scss">
.entity-details{
    .entity-logo{
        width: 50px;
    }
    .entity-image{
        width: 100%;
    }
    .edit-entity{
        display: flex;
        margin-left: auto;
    }
    .gcmcn-filter-container{
        margin-top: 0;
    }
    .details-text{
        margin-bottom: 1rem;
    }
}
</style>




// WEBPACK FOOTER //
// src/components/page/Entities/entity-detail.vue